/** Stable DOM marker for report navigation targets. */
const REPORT_SCROLL_TARGET_DATA_ATTR = "data-report-scroll-target";

export const reportScrollTargetProps = (
  elementId: string,
): { [REPORT_SCROLL_TARGET_DATA_ATTR]: string } => ({
  [REPORT_SCROLL_TARGET_DATA_ATTR]: elementId,
});

const findOutermostScrollContainer = (
  target: HTMLElement,
): HTMLElement | undefined => {
  let scrollContainer: HTMLElement | undefined;
  let ancestor = target.parentElement;

  while (ancestor != null) {
    const { overflow, overflowY } = window.getComputedStyle(ancestor);
    if (
      ancestor.scrollHeight > ancestor.clientHeight &&
      [overflow, overflowY].some((value) => /^(auto|scroll)$/.test(value))
    ) {
      scrollContainer = ancestor;
    }
    ancestor = ancestor.parentElement;
  }

  return scrollContainer;
};

/** Smooth-scrolls the report preview without offsetting clipped page content. */
export const scrollToReportScrollTarget = (elementId: string): void => {
  const target = Array.from(
    document.querySelectorAll<HTMLElement>(
      `[${REPORT_SCROLL_TARGET_DATA_ATTR}]`,
    ),
  ).find(
    (element) =>
      element.getAttribute(REPORT_SCROLL_TARGET_DATA_ATTR) === elementId &&
      element.closest('[aria-hidden="true"]') == null,
  );
  if (target == null) return;

  const scrollContainer = findOutermostScrollContainer(target);
  if (scrollContainer == null) {
    window.scrollTo({
      behavior: "smooth",
      top: window.scrollY + target.getBoundingClientRect().top,
    });
    return;
  }

  scrollContainer.scrollTo({
    behavior: "smooth",
    top:
      scrollContainer.scrollTop +
      target.getBoundingClientRect().top -
      scrollContainer.getBoundingClientRect().top,
  });
};
